import { SVGProps } from "react";

const History = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={20}
    height={20}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M3.70457 14.4084C4.78396 15.8695 6.36319 16.8985 8.15213 17.3063C9.94107 17.7141 11.8196 17.4733 13.4425 16.6282C15.0654 15.7831 16.3237 14.3905 16.9863 12.7061C17.6489 11.0217 17.6712 9.15874 17.0492 7.45947C16.4271 5.76021 15.2025 4.33876 13.6003 3.45629C11.998 2.57382 10.1258 2.2896 8.32764 2.65584C6.52942 3.02208 4.92598 4.01419 3.81189 5.44989C2.6978 6.88559 2.14789 8.66845 2.2632 10.4709M2.2632 10.4709L0.833334 9.06468M2.2632 10.4709L3.69306 9.06468"
      stroke="currentColor"
      strokeWidth={1.4}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10 5.83325V10.119L13.3333 13.3333"
      stroke="currentColor"
      strokeWidth={1.4}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export default History;
